export default {
    apiKey: "AIzaSyAlWefcg2svYOseKMMjcUzgZKY9s8skOqo",
  authDomain: "unray202109.firebaseapp.com",
  databaseURL: "https://unray202109-default-rtdb.firebaseio.com",
  projectId: "unray202109",
  storageBucket: "unray202109.appspot.com",
  messagingSenderId: "129152219966",
  appId: "1:129152219966:web:cae6e81b752184e043ca6f",
  measurementId: "G-D9ZVYKEX38"
}


// WEBPACK FOOTER //
// ./src/config.js